import React, { Fragment, useRef, useEffect } from "react";
import { FieldArray, useFormikContext } from "formik";
import HoverIconButton from "components/HoverIconButton";
import { getTemplatePrice } from "utils/constants/price";
import PriceForm from "components/PriceForm";
import Separator from "components/Separator";
import get from "lodash/get";

const PriceFormList = ({ product, name, priceHeaderPrefix }) => {
  const { values } = useFormikContext();
  const models = get(values, name);
  const firstAmountRef = useRef(null);
  /**
   * Set focus on the mask amount input on mount
   */
  useEffect(() => {
    firstAmountRef.current &&
      firstAmountRef.current.inputElement &&
      firstAmountRef.current.inputElement.focus();
  }, []);

  return (
    <Fragment>
      <FieldArray
        name={name}
        render={(arrayHelpers) => (
          <ul className="list ma0 pa0 w-100 h-100">
            {models &&
              models.map((_, modelIx) => {
                const isLast = modelIx === models.length - 1;
                const modelName = `${name}[${modelIx}]`;
                const newPriceProps = {
                  priceHeaderPrefix: priceHeaderPrefix,
                  pathPrefix: `${name}[${modelIx}]`,
                  name: modelName,
                  product: product,
                  priceIx: modelIx,
                  arrayHelpers: arrayHelpers
                };
                if (!modelIx) {
                  newPriceProps.innerAmountRef = firstAmountRef;
                }
                return (
                  <Fragment key={modelIx}>
                    <PriceForm {...newPriceProps} />
                    {!isLast && (
                      <Separator
                        customClasses={{ container: "w-100 ph0 mt2 pv3 dib" }}
                      />
                    )}
                  </Fragment>
                );
              })}
            <div className="w-100 mt3 bt hairline-1">
              <div className="flex flex-row justify-start pt3">
                <div className="flex flex-row w-100 justify-end items-center">
                  <div className="fw5 f5 pr2">{`Add price`}</div>
                  <HoverIconButton
                    type="add"
                    tooltip="Add"
                    onClick={() => {
                      const prodId = product && (product.uid || product.id);
                      arrayHelpers.push(getTemplatePrice(prodId));
                    }}
                  />
                </div>
              </div>
            </div>
          </ul>
        )}
      />
    </Fragment>
  );
};

export default PriceFormList;
